import {makeAutoObservable} from 'mobx';

import {Filter} from '_/utilities';
import {CasusStateTranslation} from '_/utilities/casus.utils';

import {CasusSearchFilter, CasusStateFilter} from './CasusAutocomplete.types';

export class CasusSearchFilters {
  public stateFilter = new Filter<CasusStateFilter[], true>(['ACTIVE']);
  public filters = [this.stateFilter];

  public constructor() {
    makeAutoObservable(this, {}, {autoBind: true});
  }

  public get modified(): boolean {
    return this.filters.some((filter) => filter.isModified());
  }

  public get casusSearchFilters(): CasusSearchFilter {
    return {stateFilters: this.stateFilter.valueOrDefault};
  }

  public get searchFilterText(): string {
    return this.stateFilter.item
      .map((state) => CasusStateTranslation[state])
      .join(', ');
  }
}
